var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "the-sidebar" },
    [
      _c(
        "b-sidebar",
        {
          attrs: {
            id: "sidenav-main",
            backdrop: "",
            "backdrop-variant": "primary",
          },
        },
        [
          _c("router-link", { staticClass: "brand", attrs: { to: "/" } }, [
            _c("img", {
              staticClass: "brand-img",
              attrs: {
                src: require("../../assets/logo.png"),
                alt: "logo image",
              },
            }),
          ]),
          _c(
            "nav",
            [
              _c(
                "b-nav",
                { attrs: { vertical: "" } },
                [
                  _c("router-link", { attrs: { to: "/legajos", tag: "li" } }, [
                    _c("span", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/icons/legajos.svg"),
                          alt: "legajos image",
                        },
                      }),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("lang.sidebar.files")) + " "),
                  ]),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/usuarios", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/usuario.svg"),
                                alt: "usuario image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.users")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/equipos", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/equipos.svg"),
                                alt: "equipos image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.teams")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/categorias", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/categorias.svg"),
                                alt: "categorias image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("lang.sidebar.categories")) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/documentos", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/documentos.svg"),
                                alt: "documentos image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.documents")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/records", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/fichas.svg"),
                                alt: "fichas image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.records")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/options", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/opciones.svg"),
                                alt: "options image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.options")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/datos", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/datos.svg"),
                                alt: "datos image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.data")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/settings", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/settings.svg"),
                                alt: "settings image",
                              },
                            }),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("lang.sidebar.settings")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/etiquetas", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/settings.svg"),
                                alt: "tags image",
                              },
                            }),
                          ]),
                          _vm._v(" Etiquetas "),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isCommonUser
                    ? _c(
                        "router-link",
                        { attrs: { to: "/reportes", tag: "li" } },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/icons/settings.svg"),
                                alt: "reportes image",
                              },
                            }),
                          ]),
                          _vm._v(" Reportes "),
                        ]
                      )
                    : _vm._e(),
                  _c("li", { on: { click: _vm.logout } }, [
                    _c("span", { staticClass: "icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            viewBox: "0 0 512 512",
                            width: "20px",
                            height: "20px",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "#48B0DA",
                              d: "M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15\n                  c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724\n                  c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262\n                  C276.412,478.129,266.908,468.625,255.15,468.625z",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              fill: "#48B0DA",
                              d: "M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173\n                  H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173\n                  c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575\n                  c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("lang.sidebar.logout")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }